import storageService from "./storageService";

export const primaryColor = () => {
  return "#E31F26";   // brand red primary
};

export const secondaryColor = () => {
  return "#FFEFEF";   // brand red secondary
};